import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";

interface ISection {
  title?: React.ReactNode;
  titleProps?: TypographyProps;
  children: React.ReactNode;
  stackProps?: StackProps;
  sx?: any;
}

const Section = ({ title, titleProps, children, stackProps, sx }: ISection) => {
  return (
    <Stack spacing={1} sx={{ ...sx }}>
      <Typography variant="textS600" color="dsNeutral.v300" {...titleProps}>
        {title}
      </Typography>
      <Stack spacing={0} {...stackProps}>
        {children}
      </Stack>
    </Stack>
  );
};

export default Section;
